import { Observable } from "rxjs";
import { GenericListView } from "../genericlistview/generic-list-view";
import { WrapperStandardFilter } from "../../common/models/wrapper.model";

interface Country {
    name: string;
}
interface HomeCountry{
    name:string;
    code:string;
}
interface WorkCountry{
    name:string;
    code:string;
}

export class GenericAutoCompleteProperties<T>  extends GenericListView<T>{
    options: Country[] = [];
    options1:HomeCountry[]=[];
    options2:WorkCountry[]=[];
    filteredOptions!: Observable<Country[]>;
    filteredOptions1!: Observable<WorkCountry[]>;
    filteredOptions2!: Observable<HomeCountry[]>;

    private _setACViewDataSourceURL:string='';
    private _sortColumn:string="";

    
    
    set setACDataSourceURL(val: any) {
        this._setACViewDataSourceURL = val;
    }
    get getACDataSourceURL(): any {
        return this._setACViewDataSourceURL;
    }
    set setACSortColumn(val: any) {
        this._sortColumn = val;
    }
    get getACSortColumn(): any {
        return this._sortColumn;
    }
}
